import { render, staticRenderFns } from "./imageDetailSection.vue?vue&type=template&id=87479e28&scoped=true&"
import script from "./imageDetailSection.vue?vue&type=script&lang=js&"
export * from "./imageDetailSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87479e28",
  null
  
)

export default component.exports